import api from "./api";

export const slideshowService = {
  getSlides: async () => {
    const response = await api.get("/app/slideshow");
    return response.data?.data?.slides || [];
  },
};

